// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import React from "react";
import { Checkbox } from "semantic-ui-react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import { i18next } from "@translations/invenio_app_rdm/i18next";

import { CreatibutorsField } from "../../components/components/Creatibutors/CreatibutorsField";

const MetadataToggle = (props) => {
  const { filesEnabled } = props;
  const { setFieldValue } = useFormikContext();

  const handleOnChangeMetadataOnly = () => {
    setFieldValue("files.enabled", !filesEnabled);
    setFieldValue("access.files", "public");
  };

  return (
    <span id="metadata-toggle">
      <Checkbox
        toggle
        label={i18next.t("Nur-Metadaten-Satz")}
        onChange={handleOnChangeMetadataOnly}
      />
    </span>
  );
};

export default MetadataToggle;

MetadataToggle.propTypes = {
  filesEnabled: PropTypes.bool.isRequired,
};

export const overriddenComponents = {
  "ReactInvenioDeposit.MetadataOnlyToggle.layout": MetadataToggle,
  "InvenioAppRdm.Deposit.CreatorsField.container": CreatibutorsField,
};
